import React, {useState, useEffect, Fragment, createRef } from "react";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import {
    Button,
    Container,
    Grid,
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    FormHelperText,
    Alert,
    AlertTitle,
  } from "@mui/material";
  import { useHistory } from "react-router-dom";
  import * as ContactingApi from "../../Requests/contactingAPIs";
  import {
    CHUIDropDown,
    CHUIDatePicker,
    CHUIProgressBackdrop,
    useCHUIDarkModeContext,
  } from "@connecthealth-ui/core";
  import {Formik, Form, useFormikContext} from 'formik';
  import {Call, VideoCall, Group, LocationOn, Person} from '@mui/icons-material';



    //sx styles
    const iconStyle = { 
        display: { xs: 'none', md: 'block',},
        marginRight: "5px"
    }

    const iconTextDiv = {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    }

    const questionStyle = {
        marginTop: "80px",
    }

    const formikStyle = {
        marginTop: "60px",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }

  
  export function OptInBooking(props) {
    const { push } = useHistory();
    const [loading, setLoading] = useState(true);
    const [errorOccurred, setErrorOccurred] = useState(false);
    const [optInBookingInfo, setOptInBookingInfo] = useState({
        "firstName": "",
        "appointmentTypeOptions":[],
        "clinician":"",
        "location":"",
        "daysSinceLastAppointment":-1,
        "AppointmentBookingGUID" : ""
    });
    const { prefersDarkMode } = useCHUIDarkModeContext();
    const formik = useFormikContext();

    let reCaptchaRef = createRef()
    //max date a user can select 
    let maxDate = new Date();
    let minDate = new Date();
    maxDate.setDate(maxDate.getDate() + optInBookingInfo["daysSinceLastAppointment"]);
    minDate.setDate(minDate.getDate() - 1);


    useEffect(() => {
      document.title = "Connect Health | Opt In Booking";
    }, []);

    
    useEffect(() => {
        if(optInBookingInfo["daysSinceLastAppointment"] > 28){
            push(`/Booking/OptInBookingInvalid?reason=expired`);
        }
      }, []);


    
    useEffect(() => {
        let patientInformation = JSON.parse(localStorage.getItem("patientInformation"));
        setOptInBookingInfo({
            "firstName": patientInformation["firstName"],
            "appointmentTypeOptions":patientInformation["appointmentTypes"],
            "clinician":patientInformation["clinician"],
            //TODO uncomment once location returned from API
            // "location":patientInformation["location"],
            "location":null,
            "daysSinceLastAppointment":patientInformation["daysSinceLastApt"],
            "AppointmentBookingGUID":patientInformation["AppointmentBookingGUID"]
        })
        setLoading(false);
    }, []);


  
    if (loading) {
      return <CHUIProgressBackdrop color="secondary" />;
    } else {
    return (
        <Fragment>
            <Paper
                sx={{
                padding: {
                    xs: 0,
                    sm: 3,
                    md: 5,
                },
                paddingBottom: {
                    xs: 5,
                    md: 8,
                },
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        textAlign: "center",
                        padding: 3,
                    }}
                >
                Hello {optInBookingInfo["firstName"]}, 
                </Typography>
                <Container maxWidth="md">
                    <Paper
                        sx={{
                        padding: 5,
                        }}
                        elevation={prefersDarkMode ? 2 : 1}
                    >

                        <Formik
                            sx={formikStyle}
                            initialValues={{
                                "appointmentType": "",
                                "earliestAppointment": "",
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={ async (values, { setSubmitting }) => {
                                let appointmentType = values["appointmentType"];
                                if(optInBookingInfo["appointmentTypeOptions"].length == 1){
                                    appointmentType = optInBookingInfo["appointmentTypeOptions"][0];
                                }

                                let earliestAppointment = new Date(values["earliestAppointment"]);
                                earliestAppointment = `${earliestAppointment.getFullYear()}-${(earliestAppointment.getMonth() + 1)}-${earliestAppointment.getDate()}T00:00:00`;


                                //build response
                                let request = {
                                    "AppointmentBookingGUID": optInBookingInfo["AppointmentBookingGUID"],
                                    "IsFaceToFaceAppointment": appointmentType == "Face to Face" ? true : false,
                                    "IsTelephoneAppointment":  appointmentType == "Telephone" ? true : false,
                                    "IsVirtualAppointment":  appointmentType == "Virtual" ? true : false,
                                    "EarliestAppointmentDate": earliestAppointment
                                }

                                

                                let response = await ContactingApi.RequestAppointmentBooking(request);
                                if(response["StatusCode"] == "200")
                                {
                                    localStorage.removeItem("patientInformation");

                                    push(`/Booking/OptInBookingConfirmation?clinician=${optInBookingInfo["clinician"]}`);
                                }
                                else
                                {
                                    setErrorOccurred(true);
                                }
                            }}
                            validationSchema={
                                optInBookingInfo.appointmentTypeOptions.length > 1 ?
                                    Yup.object().shape({
                                        appointmentType: Yup.string().required("This field is required"),
                                        earliestAppointment:
                                            Yup
                                            .date()
                                            .min(minDate, `Your earliest date must be at within 45 days after your last appointment, before ${maxDate.toDateString()}`)
                                            .max(maxDate, `Your earliest date must be at within 45 days of your last appointment, before ${maxDate.toDateString()}`)
                                            .required("This field is required"),
                                    })
                                :
                                    Yup.object().shape({
                                        earliestAppointment:
                                            Yup
                                            .date()
                                            .min(minDate, `Your earliest date must be at within 45 days after your last appointment, before ${maxDate.toDateString()}`)
                                            .max(maxDate, `Your earliest date must be at within 45 days of your last appointment, before ${maxDate.toDateString()}`)
                                            .required("This field is required"),
                                    })
                            }
                        >
                            {(props) => (
                                <Form >
                                    {
                                        optInBookingInfo.appointmentTypeOptions.length > 1 &&
                                        <CHUIDropDown 
                                            sx={{
                                                "margin-bottom":"20px"
                                            }}
                                            id="appointmentType"
                                            name="appointmentType"
                                            question="What type of appointment would you like?"
                                            options={optInBookingInfo.appointmentTypeOptions.map((option) => (
                                                {
                                                    "text": option,
                                                    "value": option
                                                }
                                            ))}
                                        />
                                    }
                    
                    
                                    <Grid 
                                        container 
                                        sx={questionStyle}
                                    >
                                        <CHUIDatePicker
                                            id="earliestAppointment"
                                            name="earliestAppointment"
                                            question="Please enter the earliest appointment date that you can attend, we will find you the earliest appointment for your care."
                                            minDate={new Date()}
                                            maxDate={maxDate}
                                        />
                                    </Grid>
                                    {getErrorMessage(props, "earliestAppointment")}
                    
                    
                                    <Grid 
                                        container 
                                        sx={questionStyle}
                                    >
                                        <TableContainer sx={{ maxWidth:"600px" }}>
                                            <Table sx={{ maxWidth:"600px"}} aria-label="simple table">
                                                <TableBody sx={{fontSize:50}}>
                                                    {
                                                        optInBookingInfo.appointmentTypeOptions.length == 1 &&
                                                        <TableRow
                                                            key="ApptType"
                                                            sx={{ 
                                                                '&:last-child td, &:last-child th': { border: 0} 
                                                            }}
                                                        >
                                                            <TableCell component="th" scope="row" width="35%">
                                                                <div style={iconTextDiv}>
                                                                    {
                                                                        optInBookingInfo["appointmentTypeOptions"][0] == "Telephone" ?
                                                                            <Call
                                                                                color="secondary"
                                                                                sx={iconStyle}
                                                                            />
                                                                        :
                                                                        optInBookingInfo["appointmentTypeOptions"][0]  == "Virtual" ?
                                                                            <VideoCall
                                                                                color="secondary"
                                                                                sx={iconStyle}
                                                                            />
                                                                        :
                                                                            <Group
                                                                                color="secondary"
                                                                                sx={iconStyle}
                                                                            />
                                                                    }
                                                                    <Typography> <strong> Appointment Type </strong></Typography>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell align="left" width="65%">
                                                                <Typography>{optInBookingInfo["appointmentTypeOptions"][0]}</Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    }

                                                    {/* <TableRow
                                                        key="Location"
                                                        sx={{ 
                                                            '&:last-child td, &:last-child th': { border: 0} 
                                                        }}
                                                    >
                                                        <TableCell component="th" scope="row" width="35%">
                                                            <div style={iconTextDiv}>
                                                                <LocationOn
                                                                    color="secondary"
                                                                    sx={iconStyle}
                                                                />
                                                                <Typography><strong> Location </strong></Typography>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="left" width="65%">
                                                            <Typography>{optInBookingInfo["location"]}</Typography>
                                                        </TableCell>
                                                    </TableRow> */}

                                                    <TableRow
                                                        key="clinician"
                                                        sx={{ 
                                                            '&:last-child td, &:last-child th': { border: 0 } 
                                                        }}
                                                    >
                                                        <TableCell component="th" scope="row" width="35%">
                                                            <div style={iconTextDiv}>
                                                                <Person
                                                                    color="secondary"
                                                                    sx={iconStyle}
                                                                />
                                                                <Typography><strong> Clinician </strong></Typography>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="left" width="65%">
                                                            <Typography>{optInBookingInfo["clinician"]}</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                    
                                    <ReCAPTCHA
                                        ref={reCaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                        onChange={(value) => {
                                            props.setFieldValue("recaptcha", value);
                                            props.setSubmitting(false);
                                        }}
                                        size="invisible"
                                    />
                    
                                    <Grid container direction="row" justifyContent="center" alignItems="center" >
                                        <Button
                                            style={{ marginTop: "40px" }}
                                            variant="contained"
                                            color="secondary"
                                            size="large"
                                            type="submit"
                                            disabled={props.isSubmitting}
                                        >
                                            {props.isSubmitting ? "submitting" : "submit"}
                                        </Button>
                                    </Grid>
                    
                                </Form>
                            )}
                        </Formik>
                    </Paper>
                </Container>
                {errorOccurred &&
                    <Grid container direction="row" justifyContent="center" alignItems="center" style={{marginTop:"20px"}}>
                      <Alert severity="error">
                        <AlertTitle>Error Occurred</AlertTitle>
                            <strong>An error has occurred please check over your input and if the issues persists please contact servicedesk@connecthealth.co.uk</strong>
                      </Alert>
                    </Grid> 
                }     
            </Paper>
        </Fragment>
      );
    }
  }
  


  function getErrorMessage(props, name){
    let error = props.errors[name] ? 
        (<FormHelperText
            error={true}
            style={{ color: "#f44336"}} 
        >
            {props.errors[name]}
        </FormHelperText>)
    :
        null

    return error
  }